import React from 'react';
import FormikAutocomplete from './FormikAutocomplete';

interface filteredAutocompleteByCourseProps {
  column: string;
  keyForFilter: string;
  lookup: any[];
  formikProps: any;
  type: string;
  label: string;
  field: string;
  fullWidth: boolean;
  myLabel: string;
  disabled: boolean;
  user?: string;
}

///ESTE ES UNICAMENTE PARA INSTANCIAS.
const FilteredAutocompleteByCourse = ({
  lookup,
  formikProps,
  label,
  field,
  fullWidth,
  myLabel,
  disabled,
}: filteredAutocompleteByCourseProps) => {
  const lookupData = lookup.find((x: any) => x.column === 'sector'); /// Cambiando esto

  if (!lookupData) {
    return null;
  }

  let useMyLabel = '';
  if (myLabel !== '#') {
    useMyLabel = myLabel;
  } else {
    useMyLabel = label;
  }

  return (
    <FormikAutocomplete
      options={lookupData}
      name={field}
      displayValue={'name'}
      keyValue={'iD_Sector'}
      label={useMyLabel}
      formikProps={formikProps}
      fullWidth={fullWidth}
      disabled={disabled}
    />
  );
};

export default FilteredAutocompleteByCourse;
